import { render, staticRenderFns } from "./alertlog.vue?vue&type=template&id=2b18b15a&"
import script from "./alertlog.vue?vue&type=script&lang=js&"
export * from "./alertlog.vue?vue&type=script&lang=js&"
import style0 from "./alertlog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports